<template>
    <div class="af">
        <div style="margin-bottom: 20px;margin-top: 20px">
            <el-table class="table"
                      border
                      ref="multipleTable"
                      :data="tableData"
                      height="500"
                      size="mini"
                      :row-class-name="tableRowClassName"
                      tooltip-effect="dark"
            >
                <el-table-column
                        align="left"
                        prop="i_id"
                        label="ID"
                        width="60"
                >
                </el-table-column>
                <el-table-column
                        align="left"
                        prop="vc_pzname"
                        :label="$t('form_product_name')"
                        show-overflow-tooltip>
                </el-table-column>
                <el-table-column
                        align="left"
                        prop="vc_unit"
                        label="单位"
                >
                </el-table-column>
                <el-table-column
                        align="left"
                        prop="f_num"
                        label="数量"
                        show-overflow-tooltip>
                    <template slot-scope="scope">
                        <el-input-number :controls="false" :precision="3" class="" size="mini" v-model="scope.row.f_num"></el-input-number>
                    </template>
                </el-table-column>
                <el-table-column
                        align="left"
                        prop="f_jsdj"
                        label="结算单价">
                    <template slot-scope="scope">
                        <el-input-number :controls="false" :min="0" :precision="3" class="" disabled size="mini" v-model="scope.row.f_jsdj" >
                             {{ (scope.row.f_jsdj = scope.row.f_zj /scope.row.f_num) | keepTwoNum}}
                        </el-input-number>
                    </template>
                </el-table-column>
                <el-table-column
                        sortable
                        prop="f_zj"
                        label="总价">
                    <template slot-scope="scope">
                        <el-input-number :controls="false" :min="0" :precision="2" class="" size="mini" v-model="scope.row.f_zj">
                           <!-- {{ (scope.row.f_zj = scope.row.f_num *scope.row.f_jsdj) | keepTwoNum}}-->
                        </el-input-number>
                    </template>
                </el-table-column>

                <el-table-column align="center"  width="50" >
                    <template slot="header" slot-scope="scope">
                        <el-popover
                                class="pop"
                                placement="bottom-end"
                                width="1000"
                                trigger="manual"
                                v-model="visible">
                            <template>
                                <self-details v-if="visible==true" :productDetails="productDetails" @closePop="closePop" @transValue="transValue"></self-details>
                            </template>
                            <el-button class="addbtn" @click="popShow" slot="reference" :disabled="isbtn" ><i class="el-icon-plus"></i></el-button>
                        </el-popover>
                    </template>
                    <template  slot-scope="scope">
                        <div class="iconminus">
                            <span class="minus" @click="deleteRow(scope.row,scope.$index)"><i class="el-icon-minus"></i></span>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div slot="footer" class="dialog-footer" style="text-align: center">
            <el-button type="primary" @click="saveNh" :disabled="disabled" :class="baseerp+'btn'" size="small">{{$t('button_save')}}</el-button>
            <el-button @click="cancel" size="small">{{$t('button_cancel')}}</el-button>
        </div>
    </div>
</template>

<script>
    import * as API from "./api"
    import {baseerp} from "@/utils/baseUrl";
    import SelfDetails from "./SelfDetails";

    export default {
        name: "SelfCostlist",
        components: {SelfDetails},
        props:{
            application:{
                type:Object,
                required:true,
            }
        },
        filters: {
            keepTwoNum(value){
                value = Number(value);
                return value.toFixed(2)
            }
        },
        data(){
            return{
                gsname:"",
                bmname:"",
                sqName:"",
                ckname:"",
                groupid:0,
                formData:{
                    gsname:"",
                    bmname:"",
                    sqName:"",
                    ckname:"",
                    num:"000000",
                    vc_note:"",
                    kcsl:"",
                    vc_lruname:"",
                    date:"",
                    tableData:[]
                },
                formRules:{
                    f_num:[{required:true,message:"请填写出库量",trigger:"blur"},],
                },
                companyName:[],
                groupName:[],
                personName:[],
                warehouseName:[],
                tableData:[],
                f_num:"",
                visible:false,
                productDetails:{},
                vc_note:"",
                date:"",
                disabled:false,
                isbtn:false,
                edit:false,
                data:{},
                i_pid:0,
                state:0,
                qgsname:"",
                qckname:"",
                gsid:0,
                gid:0,
                i_rwid:0,
                ckid:0,
                squid:0,
                index:0,
                pageSize:1,
                baseerp:"",
                form:{},
                mid:0,
            }
        },
       /* watch: {
            application: {
                handler() {
                    if (this.application) {
                        this.pageSize=this.application.page_size;
                        this.i_id = this.application.i_id;
                        this.mid = this.application.i_mid;
                        // console.log(this.mid,"this.mid");

                        this.i_pid = this.application.i_pid;
                        this.i_type = this.application.i_type;
                        this.formData={
                            gsname:this.application.value.vc_gsname,
                            bmname:this.application.value.vc_cjname,
                            sqName: sessionStorage.getItem("lruname"),
                            ckname:this.application.value.vc_ckname,
                            num:this.i_pid,
                            // vc_note:this.application.vc_note,
                            vc_lruname: sessionStorage.getItem("lruname"),
                            date:this.application.value.dt_createtime,
                        };
                        this.gsid=this.application.value.i_gsid;
                        this.gid=this.application.value.i_cjid;
                        this.ckid=this.application.value.i_ckid;
                        if ((this.i_pid ?? '' !== '') && this.i_pid != 0) {
                            this.edit = true;
                            this.getCjReturnDetails();
                        } else if (this.i_pid == 0) {
                            this.productDetails.gsid=this.application.value.i_gsid;
                            this.productDetails.i_mid=this.mid;
                            this.productDetails.i_type=this.i_type;
                            this.productDetails.ckid=this.application.value.i_ckid;
                            this.productDetails.gsid_out=this.application.value.i_gsid_out;
                            this.productDetails.i_pzid=this.application.value.i_pzid;
                            this.productDetails.i_cjid=this.application.value.i_cjid;
                            this.productDetails.selected=[];
                            this.edit = false;
                            /!*this.getCompanyList();
                            this.getGroupList();
                            this.getWarehouseList();*!/
                            this.getDateYYYYMMddHHMMSS();
                        }
                        // console.log(this.application, "this.application");
                    }
                },
                immediate: true,
                deep: true
            }
        },*/
        mounted() {
            this.baseerp=baseerp;
            //console.log(this.application,"自产this.cost");
            this.productDetails.i_id=this.application.i_id;
            //console.log(this.productDetails.i_id,"-----------")
            this.getNhDetails();
        },
        methods:{


            async getNhDetails(){
                let param={
                    i_mid:this.mid,
                    i_id:this.application.i_id,
                };
                let res=await API.getNhDetails(param);
                if(res.code==1){
                    let data=res.data;
                    this.tableData=data;
                    // console.log(data,"data");
                    /*this.formRules={};
                    this.formData={
                        gsname:data.vc_gsname,
                        bmname:data.cjname,
                        sqName:data.vc_squname,
                        ckname:data.vc_outckname,
                        num:data.i_id,
                        vc_note:data.vc_note,
                        vc_lruname:data.vc_lruname,
                        date:data.dt_createtime,
                        tableData:data.details,
                    };*/
                    // this.state=data.i_state;
                    //this.tableData=data.details;
                    //this.gsid=data.i_outgsid;
                    /*this.gsid=data.i_gsid;
                    this.gid=data.i_cjid;
                    this.squid=data.i_squid;
                    this.sqName=data.vc_squname;
                    this.i_lruid=data.i_lruid;
                    this.i_lruname=data.i_lruname;*/
                    //this.ckid=data.i_outckid;
                    /*this.ckid=data.i_ckid;
                    this.productDetails.gsid=data.i_gsid;
                    this.productDetails.i_mid=this.mid;
                    this.productDetails.ckid=data.i_ckid;
                    this.productDetails.gsid_out=data.i_gsid_out;
                    this.productDetails.i_pzid=data.i_pzid;
                    this.productDetails.i_type=data.i_type;
                    this.productDetails.selected=[];*/
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }
            },

            numinput(value){
                if (value.f_num>value.kcsl) {
                    value.f_num=value.kcsl;
                    this.$message.error("申请出库量应小于可用库存");
                    return false
                }
            },

            popShow(){
                //console.log(this.visible)
                this.visible=true;
                this.isbtn=true
                /*if (this.formData.gsname==''||this.formData.ckname==''){
                    this.$message.error("请选择公司或仓库")
                    return
                }else if(this.formData.gsname!=''&&this.formData.ckname!=''){
                    this.visible=true;
                }
                if (this.visible==true){
                    this.isbtn=true
                }*/
            },

            closePop(){
                this.visible=false;
                this.isbtn=false;
            },

            //产品列表
            transValue(value){
                /*let arr=[];
                if ( this.formData.tableData.length>0){

                }else {
                     arr=[...value];
                }*/
                let arr=[...this.tableData,...value];
                //console.log(value,"------------");


                //console.log(arr,"arrrrrrrrrrrrr")
                /*const vc_pzid='vc_pzid';
                const vc_no='vc_no';
                const i_scid='i_scid';
                //console.log(item,"--item--",next)
                const newArr = arr.reduce((all,next)=>all.some((item)=>item[vc_pzid]==next[vc_pzid])?all:[...all,next],[]);
                const newArr2 = newArr.reduce((all,next)=>all.some((item)=>item[vc_no]==next[vc_no])?all:[...all,next],[]);
                const newArr3 = newArr2.reduce((all,next)=>all.some((item)=>item[i_scid]==next[i_scid])?all:[...all,next],[]);

*/
                /*let hash = {};
                arr = arr.reduce(function(item, next) {
                    hash[next.vc_unique] ? '' : hash[next.vc_unique] = true && item.push(next);
                    return item
                }, []);*/
                this.formData.tableData=arr;
                this.tableData=arr;
                //console.log(this.tableData,"this.tabledata");
                this.productDetails.selected=this.tableData;
                //console.log("**arr**",newArr3)
            },

            deleteRow(value,index){
                this.index=index;
                this.tableData.splice(this.index,1);
                // console.log(value,"-----")
            },

            //提交审批
            toApprove(){
            },

            cancel(){
                //console.log(this.pageSize,"------")
                this.visible=false;
                this.$emit('close');

                //this.$emit('getPickingReqList')
            },

            //保存
            async saveNh(){
                //console.log(this.tableData,"this.tableData");
                /*let details = this.tableData.filter(item=>item.f_num!=0);
                if (details.length==0){
                    this.$message.error("请添加申请出库量");
                    return ;
                }*/
                this.disabled=true;
                let param={
                    i_mid: this.mid,
                    //i_id:this.i_pid,
                    //i_rwid:this.i_id,
                    //i_outgsid:this.gsid,
                    //i_gsid:this.gsid,
                    //i_cjid:this.gid,
                    //i_outckid:this.ckid,
                   // i_ckid:this.ckid,
                   // i_squid:sessionStorage.getItem("userid"),
                    //vc_squname:sessionStorage.getItem("lruname"),
                    //vc_note:this.formData.vc_note,
                    details:this.tableData,
                };
                let res=await API.saveNh(param);
                if(res.code==1){
                    this.$message.success(res.message);
                    this.visible=false;
                    //this.$emit('getCjReturnList',this.pageSize);
                    this.cancel();
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }
            },

            //获取当天日期
            getDateYYYYMMddHHMMSS(){
                const date = new Date();
                const month = (date.getMonth() + 1).toString().padStart(2, '0');
                const strDate = date.getDate().toString().padStart(2, '0');
                //return `${date.getFullYear()}-${month}-${strDate}`;
                this.formData.date=`${date.getFullYear()}-${month}-${strDate}`;
                //console.log(this.formData.date)
            },

            tableRowClassName({row,rowIndex}){
                //console.log(row.i_gsid,this.gsid)
                /*if(row.i_gsid!=this.gsid){
                    return 'danger-row';
                }*/
                if (row.isother == 1) {
                    return 'danger-row';
                }
            },
        }
    }
</script>

<style lang="scss" >
    .flex{
        display: flex;
    }
    .el-icon-plus {
        font-size: 20px;
        color: #3e82e8;
        font-weight: bolder;
    }
    .num .el-form-item__label {
        color: #b3d268;
        font-size: 16px;
        font-style: italic;
    }
    .num .el-form-item__content {
        width: 130px;
    }
    .pop .addbtn{
        border: none;
        padding: 0;
    }
    .tableForm-item{
        margin: 0;
        width: 100%;
        /deep/{
            .el-form-item__content{
                width: 100%;
                margin-left: 0 !important;
            }
        }
    }
    .changeinput{
        border: 1px solid #e0e0e0;
        border-radius: 4px;
    }
    .table {
        .el-form-item--mini.el-form-item, .table.el-form-item--small.el-form-item {
            margin-bottom: 0px;
        }
    }
    /deep/{
        .table {
            .el-form-item--mini.el-form-item, .table.el-form-item--small.el-form-item {
                margin-bottom: 0px;
            }
        }
        .el-input__inner {
            height: 24px;
            line-height: 24px;

        }
        .cell .el-input__inner{
            height: 24px;
            line-height: 24px;
        }
        .el-table .cell{
            height: 24px;
            line-height: 24px;
        }
        .el-input-number--mini {
            width: 96px;
            line-height: 26px;
        }
        .danger-row{
            color: #999;
        }
    }

</style>
